import { Button, toast } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { PlusIcon } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  useDeleteEventCategory,
  useEventCategoriesQuery,
} from "../api/queries";
import { EventCategoryTable } from "../ui/EventCategoryTable";

export function EventCategoriesPage() {
  const nav = useNavigate({
    from: "/app/performance/settings/event-categories",
  });
  const list = useEventCategoriesQuery();
  const canCreate = useActionPermission(["performance-events:update"]);
  const deleteCategory = useDeleteEventCategory();

  const rows = [...(list.data?.data ?? [])].sort(
    (a, b) => a.sortOrder - b.sortOrder || a.name.localeCompare(b.name),
  );

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "ຫມວດງານສະແດງ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6 flex items-center justify-between">
          <div>
            <h2 className="font-bold text-2xl tracking-tight">ຫມວດງານສະແດງ</h2>
            <p className="text-muted-foreground">
              ຈັດການປະເພດງານ ແລະ logo (Dance Performance / Fanglao Studio)
            </p>
          </div>
          {canCreate ? (
            <Button
              onClick={() =>
                nav({
                  to: "/app/performance/settings/event-categories/create",
                })
              }
            >
              <PlusIcon className="size-4" /> ເພີ່ມຫມວດ
            </Button>
          ) : null}
        </div>

        <div className="rounded-xl border bg-card pt-2">
          <EventCategoryTable
            data={rows}
            isLoading={list.isLoading}
            onEdit={(item) =>
              nav({
                to: "/app/performance/settings/event-categories/$id/edit",
                params: { id: item.id },
              })
            }
            onDelete={async (id) => {
              try {
                await deleteCategory.mutateAsync(id);
                toast.success("ລຶບຫມວດງານສຳເລັດ");
              } catch {}
            }}
          />
        </div>
      </Main>
    </>
  );
}
